/* eslint-disable camelcase */
import { useMutation, useQueryCache } from 'react-query';
import { client } from 'utils/api-client';

export default function useDeleteEducationData(staffId: string) {
  const cache = useQueryCache();
  return useMutation(
    (serviceId: string) =>
      client(`employees/service-history/${serviceId}/`, {
        method: 'DELETE',
      }).then((res) => res),
    {
      onSuccess: () => {
        cache.invalidateQueries(['employee-data', staffId]);
      },
    }
  );
}
